module.exports = __webpack_public_path__ + "static/media/20150928_174515.a8a98d8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20150928_174515.jpg
// module id = 445
// module chunks = 0